<template>
  <div>
    <template v-if="enableThirdParty">
      <ThirdPartyLogin
        :active="
          registrationData &&
            registrationData.thirdPartyId &&
            registrationData.thirdPartyId.type
        "
      />
      <DividerSeparator />
    </template>
    <form-with-captcha
      ref="registerForm"
      :request-data="user"
      @loading="setLoading"
      @success="onSuccess"
      :after-captcha-verified="services.UserResource.save"
    >
      <FieldWrapper>
        <input
          tabindex="1"
          v-model="user.username"
          name="username"
          placeholder="Nickname"
          v-validate.initial="validatorDefinitions.username"
          data-vv-scope="register"
          data-vv-delay="500"
          autocomplete="username"
        />
        <div slot="errors" v-if="errors.has('username', 'register')">
          {{ errors.first("username", "register") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <input
          tabindex="2"
          type="email"
          v-model="user.email"
          name="email"
          placeholder="E-mail"
          v-validate.initial="validatorDefinitions.email_new"
          data-vv-scope="register"
          data-vv-delay="500"
          autocomplete="email"
        />
        <div slot="errors" v-if="errors.has('email', 'register')">
          {{ errors.first("email", "register") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <input
          tabindex="3"
          type="email"
          v-model="user.email_confirmation"
          name="email_confirmation"
          placeholder="E-mail Confirmation"
          v-validate="validatorDefinitions.email_confirmation"
          data-vv-scope="register"
          autocomplete="off"
        />
        <div slot="errors" v-if="errors.has('email_confirmation', 'register')">
          {{ errors.first("email_confirmation", "register") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <PasswordStrength :password="user.password">
          <input
            tabindex="4"
            type="password"
            v-model="user.password"
            name="password"
            placeholder="Password"
            v-validate="validatorDefinitions.password_new"
            data-vv-scope="register"
          />
        </PasswordStrength>
        <div slot="errors" v-if="errors.has('password', 'register')">
          {{ errors.first("password", "register") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <input
          tabindex="5"
          type="password"
          v-model="user.password_confirmation"
          name="password_confirmation"
          autocomplete="off"
          placeholder="Password Confirmation"
          v-validate="validatorDefinitions.password_confirmation"
          data-vv-scope="register"
        />
        <div
          slot="errors"
          v-if="errors.has('password_confirmation', 'register')"
        >
          {{ errors.first("password_confirmation", "register") }}
        </div>
      </FieldWrapper>

      <FieldWrapper>
        <div slot="input" class="consent">
          <switches
            v-model="terms"
            theme="bulma"
            type-bold="true"
            name="terms"
            id="terms"
            for="terms"
            :color="terms ? 'green' : 'red'"
            v-validate="'checked'"
            data-vv-scope="register"
            class="column center"
          />
          <div class="consentText">
            By creating a Bohemia Interactive Account,<br />you accept the
            <router-link
              :to="{ name: pages.TERMS_AND_CONDITION }"
              target="_blank"
            >
              User Agreement
            </router-link>
            &amp;
            <a href="http://www.bistudio.com/privacy-policy" target="_blank"
              >Privacy Policy</a
            >.
          </div>
        </div>
        <div slot="errors" v-if="errors.has('terms', 'register')">
          {{ errors.first("terms", "register") }}
        </div>
      </FieldWrapper>

      <DecoratedButton
        tabindex="7"
        @click="onSubmit"
        name="register"
        :loading="loading"
      >
        SIGN UP
      </DecoratedButton>
    </form-with-captcha>
  </div>
</template>

<script>
import PasswordStrength from "@/components/partials/PasswordStrength";
import Switches from "@/components/partials/Switch";

import ThirdPartyLogin from "@/components/partials/auth/ThirdPartyLogin";

import FormWithCaptcha from "@/components/partials/FormWithCaptcha";

export default {
  name: "form-register",
  components: { PasswordStrength, Switches, FormWithCaptcha, ThirdPartyLogin },
  props: {
    enableThirdParty: {
      type: Boolean,
      default: true
    },
    registrationData: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      loading: false,
      terms: false,
      showConsent: false
    };
  },
  computed: {
    user: {
      get: function() {
        return {
          username: this.registrationData ? this.registrationData.username : "",
          email: this.registrationData ? this.registrationData.email : "",
          email_confirmation: "",
          password: "",
          password_confirmation: "",
          subscribed: true
        };
      },

      set: function(value) {
        return value;
      }
    }
  },
  methods: {
    setSubscribed(value) {
      this.user.subscribed = value;
    },
    setLoading(val) {
      this.loading = val;
    },
    onSuccess() {
      if (
        this.registrationData &&
        Object.keys(this.registrationData).length > 0
      ) {
        this.services.AuthService.redirect();
      } else {
        this.$emit("continue");
      }
    },
    onSubmit() {
      this.$validator.validateAll("register").then(valid => {
        if (valid) {
          this.$refs.registerForm.onSubmit();
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.consent {
  display: flex;
}

.consentText {
  text-align: left;
  margin-left: 1rem;
  font-size: 0.9rem;
}
</style>
